// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__IEXif","header":"ClearentDisclaimer_header__94bue","inner":"ClearentDisclaimer_inner__1R3pe"};